import React from "react";
import BlogContainer from "../../containers/Blog";

function Blogs() {
  return <BlogContainer />;
}

export default Blogs;
